export default __webpack_public_path__ + "static/media/Inconsolata-Bold.2d605563.ttf";